import { TrendingDown, TrendingUp, Minus } from 'lucide-react';
import { scoreColor, formatTimeLong } from './helpers';

// Vue statistiques partagée (perso ET aperçu suivi : /user/stats.php renvoie la même forme).
export default function StatsView({ stats }) {
    const g = stats.global;
    const { by_category, weakest, strongest } = stats;
    const coveragePct = g.total_questions_available > 0 ? Math.round(g.unique_questions_answered / g.total_questions_available * 100) : 0;
    const cats = [...(by_category || [])].sort((a, b) => b.avg_score - a.avg_score);
    const catColor = (s) => s >= 70 ? '#10b981' : '#f97316'; // raccord avec la légende ≥70 / <70

    return (
        <div className="stats-v2">
            {/* KPI : héros score moyen + 4 secondaires */}
            <div className="stats-kpi">
                <div className="stats-hero">
                    <div className="stats-hero__label">SCORE MOYEN</div>
                    <div className="stats-hero__value">{g.avg_score}%</div>
                    {g.score_trend != null && (
                        <span className="stats-hero__trend">
                            {g.score_trend > 0 ? <TrendingUp size={13} /> : g.score_trend < 0 ? <TrendingDown size={13} /> : <Minus size={13} />}
                            {g.score_trend === 0 ? 'stable' : `${g.score_trend > 0 ? '+' : ''}${g.score_trend} pts`} sur 30 j
                        </span>
                    )}
                </div>
                <div className="stats-mini">
                    <div className="stats-card"><div className="stats-card__num">{g.total_sessions}</div><div className="stats-card__lbl">Quiz terminés</div></div>
                    <div className="stats-card"><div className="stats-card__num">{formatTimeLong(g.total_time)}</div><div className="stats-card__lbl">Temps total</div></div>
                </div>
                <div className="stats-mini">
                    <div className="stats-card"><div className="stats-card__num" style={{ color: scoreColor(g.best_score) }}>{g.best_score}%</div><div className="stats-card__lbl">Meilleur score</div></div>
                    <div className="stats-card" title={`${g.unique_questions_correct} réussies sur ${g.unique_questions_answered} vues`}><div className="stats-card__num">{g.unique_questions_correct}</div><div className="stats-card__lbl">Questions maîtrisées</div></div>
                </div>
            </div>

            {/* Couverture du contenu */}
            <div className="stats-block">
                <div className="stats-block__head">
                    <span className="stats-block__title">Couverture du contenu</span>
                    <span className="stats-cover__meta"><b>{g.unique_questions_answered}</b> / {g.total_questions_available.toLocaleString('fr-FR')} questions vues · <b>{coveragePct}%</b></span>
                </div>
                <div className="stats-cover__track"><div className="stats-cover__fill" style={{ width: `${coveragePct}%` }} /></div>
            </div>

            {/* Maîtrise par catégorie */}
            {cats.length > 0 && (
                <div className="stats-block">
                    <div className="stats-block__head">
                        <span className="stats-block__title">Maîtrise par catégorie</span>
                        <span className="stats-legend">
                            <span><span className="stats-legend__dot" style={{ background: '#10b981' }} />≥70%</span>
                            <span><span className="stats-legend__dot" style={{ background: '#f97316' }} />&lt;70%</span>
                        </span>
                    </div>
                    <div className="stats-catbars">
                        {cats.map((cat, i) => (
                            <div key={i} className="stats-catbar">
                                <span className="stats-catbar__label" title={cat.label}>{cat.label}</span>
                                <div className="stats-catbar__track"><div className="stats-catbar__fill" style={{ width: `${Math.min(100, cat.avg_score)}%`, background: catColor(cat.avg_score) }} /></div>
                                <span className="stats-catbar__val" style={{ color: catColor(cat.avg_score) }}>{cat.avg_score}%</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Points faibles / forts (sans boutons d'action) */}
            <div className="stats-cols">
                {weakest?.length > 0 && (
                    <div className="stats-block">
                        <div className="stats-sf__head">
                            <span className="stats-sf__icon stats-sf__icon--weak"><TrendingDown size={14} /></span>
                            <span className="stats-block__title">Points faibles</span>
                        </div>
                        <div className="stats-sf__list">
                            {weakest.map((item) => (
                                <div key={item.id} className="stats-sf__row">
                                    <span className="stats-sf__label">{item.label}</span>
                                    <span className="stats-sf__val" style={{ color: scoreColor(item.avg_score) }}>{item.avg_score}%</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {strongest?.length > 0 && (
                    <div className="stats-block">
                        <div className="stats-sf__head">
                            <span className="stats-sf__icon stats-sf__icon--strong"><TrendingUp size={14} /></span>
                            <span className="stats-block__title">Points forts</span>
                        </div>
                        <div className="stats-sf__list">
                            {strongest.map((item) => (
                                <div key={item.id} className="stats-sf__row">
                                    <span className="stats-sf__label">{item.label}</span>
                                    <span className="stats-sf__val" style={{ color: scoreColor(item.avg_score) }}>{item.avg_score}%</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
